/**
 * Cart
 * Cart Display
 * Initializes line item remove + quantity updates
 * Listes for removed and quantity updates
 **/
import eventBus from '../services/event-bus';
import elementExists from '../utils/element-exists';
const CartAwareProductForm = function ($product, $current_variant, $container, hasCartDrawer = true) {
  Shopify.theme = Shopify.theme || {};
  let $theme = Shopify.theme;
  const CartService = Shopify.cartService;
  let $this = {};
  $this.hasCartDrawer = hasCartDrawer;

  $this.classes = {
    hide: 'd-none',
  };

  $this.selectors = {
    gridItem: '[data-grid-item]',
    quantityComponent: '[sh-quantity-component]',
    btnAddToCart: '[sh-add-to-cart]',
  };

  $this.attributes = {
    cartItemKey: 'data-cart-item-key',
  };

  $this.init = function () {
    $this.container = $container;
    $this.product = $product;
    $this.current_variant = $current_variant;
    $this.container.setAttribute('data-cart-item', true);

    if (typeof $theme.cartOnLoad !== 'undefined') {
      $this.cart = $theme.cartOnLoad;
    }

    $this.initElements();
    
    if (!$this.hasCartDrawer) {
      eventBus.on(eventBus.types.QuantityUpdated, $this.onQuantityUpdated);
    }

    eventBus.on(eventBus.types.CartUpdated, $this.onCartUpdated);

    if ($this.product.variants && $this.product.variants.length > 1) {
      eventBus.on(eventBus.types.OptionsSelected, $this.onOptionsSelected);
    }
  };

  $this.checkCart = function () {
    let $inCart = false;

    $this.cart.items.forEach(function (item) {
      if (!$inCart) {
        if (item.variant_id == $this.current_variant.id) {
          $inCart = true;
          
          if ( !$this.container || !$this.quantityComponent ) return

          $this.container.setAttribute('data-cart-item-key', item.key);
          $this.quantityComponent.querySelector('input').value = item.quantity;
        }
      }
    });
    
    $this.updateDisplay($inCart);
  };

  $this.initElements = function () {
    $this.quantityComponent = $this.container.querySelector($this.selectors.quantityComponent);
    $this.btnAddToCart = $this.container.querySelector($this.selectors.btnAddToCart);
    
    if (!$this.quantityComponent || !$this.btnAddToCart) return

    $this.quantityComponent.dataset.variantId = $this.current_variant.id;
    $this.quantityComponent.dataset.productId = $this.product.id;
    $this.checkCart();
  };

  $this.onOptionsSelected = function ($event) {
    $this.current_variant = $event.detail;
    $this.initElements();
  };

  $this.onCartUpdated = function ($event) {
    $this.cart = $event.detail;
    $this.checkCart();
  };

  // update the product display
  // hide the quantity
  $this.updateDisplay = function ($showQuantity = false) {
    if (!$this.quantityComponent || !$this.btnAddToCart) return

    if ($showQuantity) {
      $this.quantityComponent.classList.remove($this.classes.hide);
      $this.btnAddToCart.classList.add($this.classes.hide);
    } else {
      $this.quantityComponent.querySelector('input').value = 1;
      $this.quantityComponent.classList.add($this.classes.hide);
      $this.btnAddToCart.classList.remove($this.classes.hide);
    }
  };

  $this.onQuantityUpdated = function (e) {
    var target = e.detail.target;
    var gridItem = target.closest($this.selectors.gridItem);

    if (elementExists(gridItem)) {
      var key = gridItem.getAttribute($this.attributes.cartItemKey);
      const uid = gridItem.getAttribute($this.attributes.uid);
      const cartItem = uid ? CartService.getCartItemByUID(uid) : false;
      if (cartItem) {
        key = cartItem.key;
      }
      CartService.updateQuantity(key, e.detail.value)
    }
  };

  return $this;
};

export default CartAwareProductForm;
